import { NgModule } from '@angular/core';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';

import { CommonModule } from '@angular/common';
import { AddCityComponent } from './add-city/add-city.component';
import { AddCountryComponent } from './add-country/add-country.component';
import { CityListComponent } from './city-list/city-list.component';
import { CountryListComponent } from './country-list/country-list.component';
import { CountryCityRoutingModule } from './country-city.routing';
// import { FilterPipe } from '../shared/filter.pipe';
import {FilterPipe} from '../shared/filter.pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { CountryCityService } from './country-city.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { UpdateCountryComponent } from './update-country/update-country.component';
import { UpdateCityComponent } from './update-city/update-city.component';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';

@NgModule({
  declarations: [

    AddCityComponent,
    AddCountryComponent,
    CityListComponent,
    CountryListComponent,
    FilterPipe,
    UpdateCountryComponent,
    UpdateCityComponent
    ],
  imports: [
    CommonModule,
    CountryCityRoutingModule,
    NgxPaginationModule,
    FormsModule,
    MatSortModule,
  //  BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    ModalModule.forRoot(),
    MatTableModule


  ],
  providers: [CountryCityService, BsModalRef]
})
export class CountryCityModule { }
